import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-rpa',
  templateUrl: './rpa.component.html',
  styleUrls: ['./rpa.component.scss']
})
export class RpaComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
